import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { messageBoardAction } from '../../actions/messageBoardAction';
import moment from 'moment';

interface IUserMessagesProps {
	dispatch: Dispatch<any>;
	userId: any;
	messageBoardData: any;
}

const UserMessage: React.SFC<IUserMessagesProps> =
	({ dispatch, userId, messageBoardData }) => {

		const initialInputValue = { searchString: "", userId: userId, isPrivate: false, uniqueCode:'hotline' };

		const [messageList, setMessageList] = useState([]);
		const [isListLoaded, setIsListLoaded] = useState(false);
		const [isErrorOnPage, setIsErrorOnPage] = useState(false);

		React.useEffect(() => {
			setIsErrorOnPage(false);
			setIsListLoaded(false);
			dispatch(messageBoardAction.messageBoardGetPublicMessageByUserId({ dashboardMessagesGetInput: initialInputValue }));
		}, [userId]);

		if (messageBoardData) {
			if (messageBoardData.isError && !isErrorOnPage) {
				setIsErrorOnPage(true);
			}
			if (messageBoardData.isUserDashboardMsgLoaded) {
				messageBoardData.isUserDashboardMsgLoaded = false;
				setMessageList(messageBoardData.userDasboardMessageData);
				setIsListLoaded(true);
			}
		}

		return (
			<div>
				{isListLoaded && !isErrorOnPage && messageList.length > 0 ?
					<table className="table text-center" data-testid="messagePublicTable">
						<thead>
							<tr>
								{/*<th data-testid="messagePublicDate" key="messagePublicDate" scope="col">Date</th>*/}
								<th data-testid="messageBoardPublic" key="messageBoardPublic" scope="col">Message Board</th>
								<th data-testid="messagePublicSubject" key="messagePublicSubject" scope="col">Subject</th>
								<th data-testid="messagePublicReplies" key="messagePublicReplies" scope="col">Replies</th>
								<th data-testid="messagePublicReports" key="messagePublicReports" scope="col">Alerts</th>
							</tr>
						</thead>
						<tbody data-testid="messagePublicTableBody">
							{messageList && messageList.map((data: any, index) =>
								<tr data-testid={"messagePublicTr" + index} key={"messagePublicTr" + index}>
								{/*	<td data-testid={"messagePublicDate" + index} key={"messagePublicDate" + index}>
										{moment(data.createdAtUtc).format("MM/DD/YYYY")}
									</td>*/}
									<td data-testid={"messageBoardPublic" + index} key={"messageBoardPublic" + index}>{data.title}</td>
									<td data-testid={"messagePublicSubject" + index} key={"messagePublicSubject" + index}>{data.subject}</td>
									<td data-testid={"messagePublicReplies" + index} key={"messagePublicReplies" + index}>{data.replies}</td>
									<td data-testid={"messagePublicReports" + index} key={"messagePublicReports" + index}>{data.reports}</td>
								</tr>
							)}
						</tbody>
					</table> :
					<h5 className="text-center">No data found</h5>}
			</div>
		);
	}

const mapStateToProps = (state: any) => {
	const { messageBoardData } = state;
	return {
		messageBoardData
	};
};

export default connect(mapStateToProps)(UserMessage);